// @flow
import { isRequired, isEmail } from '@clark-inc/clark-forms';

const TERMS_FIELD_SET = [
  {
    fieldSet: [
      {
        columns: { small: 1, large: 1 },
        stripped: true,
        fields: [
          {
            type: 'checkboxField',
            name: 'termsOfService',
            validate: [isRequired],
          },
        ],
      },
    ],
  },
];

const RECEIPT_FIELD = [
  {
    fieldSet: [
      {
        columns: { small: 1, large: 1 },
        fields: [
          {
            type: 'input',
            name: 'email',
            label: 'Where do we email your receipt?',
            placeholder: 'Enter your email',
            validate: [isRequired, isEmail],
          },
        ],
      },
    ],
  },
];

const AUTOPAY_FIELD = [
  {
    fieldSet: [
      {
        columns: { small: 1, large: 1 },
        fields: [
          {
            type: 'checkbox',
            name: 'autopayEnabled',
            label: 'Enable automatic payments for all future invoices',
          },
        ],
      },
    ],
  },
];

const SUBMIT_INFO = {
  headline: 'Ready to Pay?',
  copy:
    'Add your card to pay your first invoice and set up convenient, one-click payments for future invoices.',
};

const FAQ_COPY = {
  creditCard: {
    copy: 'Learn about secure payments with Stripe',
    link: 'https://support.hiclark.com/for-students/clark-for-students',
  },
};

export { TERMS_FIELD_SET, RECEIPT_FIELD, AUTOPAY_FIELD, SUBMIT_INFO, FAQ_COPY };



// WEBPACK FOOTER //
// ./src/constants/payer/charge.js